export let RuleCategory = {
    ANTI_MONEY_LAUNDERING: 'ANTI_MONEY_LAUNDERING',
    RISK_ASSESSMENT: 'RISK_ASSESSMENT',
    RESPONSIBLE_GAMBLING: 'RESPONSIBLE_GAMBLING',
    FRAUD: 'FRAUD'
};

export function getRuleCategoryUrl(ruleCategory) {
    switch (ruleCategory) {
        case RuleCategory.ANTI_MONEY_LAUNDERING:
            return 'anti-money-laundering';
        case RuleCategory.RISK_ASSESSMENT:
            return 'risk-assessment';
        case RuleCategory.RESPONSIBLE_GAMBLING:
            return 'responsible-gambling';
        case RuleCategory.FRAUD:
            return 'fraud';
        default:
            return '';
    }
}

export function reverseRuleCategoryUrl(url) {
    switch (url) {
        case 'anti-money-laundering':
            return RuleCategory.ANTI_MONEY_LAUNDERING;
        case 'risk-assessment':
            return RuleCategory.RISK_ASSESSMENT;
        case 'responsible-gambling':
            return RuleCategory.RESPONSIBLE_GAMBLING;
        case 'fraud':
            return RuleCategory.FRAUD;
        default:
            return '';
    }
}

/*
  The category a page was opened for: the one in the state of the navigation (what the buttons of the alerts pages pass), or else
  the one in the path (/modify-rules/fraud), which is all there is when the address was typed or came from a bookmark. '' if neither
  names one.
*/
export function getRuleCategoryFromLocation(location) {
    const fromState = location && location.state && location.state.ruleCategory;

    return (
        fromState ||
        reverseRuleCategoryUrl(
            ((location && location.pathname) || '')
                .split('/')
                .filter(Boolean)[1]
        )
    );
}

export function getRuleCategoryFriendlyName(ruleCategory) {
    switch (ruleCategory) {
        case RuleCategory.ANTI_MONEY_LAUNDERING:
            return 'Anti Money Laundering';
        case RuleCategory.RISK_ASSESSMENT:
            return 'Risk Assessment';
        case RuleCategory.RESPONSIBLE_GAMBLING:
            return 'Responsible Gambling';
        case RuleCategory.FRAUD:
            return 'Fraud';
        default:
            return '';
    }
}

export function getRuleCategoryStoreRepresentation(ruleCategory) {
    switch (ruleCategory) {
        case RuleCategory.ANTI_MONEY_LAUNDERING:
            return 'AML';
        case RuleCategory.RESPONSIBLE_GAMBLING:
            return 'RG';
        case RuleCategory.FRAUD:
            return 'Fraud';
        case RuleCategory.RISK_ASSESSMENT:
            return 'RA';
        default:
            break;
    }
}
